import { gql, useMutation, useQuery } from "@apollo/client";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { DELETE_Voucher_MUTATION } from "../../../../Utils/AllPagesQuriesAndMutations";
import { AddVoucher } from "../../AddVoucher/AddVoucher";
import { Confirm } from "../../Confirmation/Confirm";
import { ErrorToast, SuccessToast } from "../../ToastComponent/RectHotToast";
import AddBankAccount from "../AddBankAccount/AddBankAccount";
import AddPaymentAccount from "../AddBankPayment/AddBankPayment";
import AddBankReceipt from "../AddBankReceipt/AddBankReceipt";
import AddCashPayment from "../AddCashPayment/AddCashPayment";
import AddcashReceipt from "../AddCashReciept/AddCashReciept";
import AddContra from "../AddContra/AddContra";
import AddCustormerAccount from "../AddCustomerAccount/AddCustomerAccount";
import AddJournalVoucher from "../AddJournalVoucher/AddJournalVoucher";
import "../AddJournalVoucher/AddJournalVoucher.scss";
import AddNominalAccount from "../AddNominalAccount/AddNominalAccount";
import AddPartyAccount from "../AddGeneralAccount/AddGeneralAccount";
import AddVendorAccount from "../AddVendorAccount/AddVendorAccount";
import "./Addledger.scss";
import AddSalesBill from "../AddSalesBill/AddSalesBill";
import AddPurchaseBill from "../AddPurchaseBill/AddPurchaseBill";
import AddLMSSalesBill from "../AddLMSSalesBill/AddLMSSalesBill";
import AddSalesReturn from "../AddSalesReturn/AddSalesReturn";
import AddGeneralAccount from "../AddGeneralAccount/AddGeneralAccount";
import AddCreditNote from "../AddCreditNote/AddCreditNote";
import AddDebitNOte from "../AddDebitNote/AddDebitNote";
import AddVendorFreightBill from "../AddFreightBill/AddFreightBill";

const AllData = gql`
  query SearchByAccountType($id: ID!) {
    Account(id: $id) {
      Proprietor_Name
      Bank_Name
      Business_Name
      BankAccount_Type
      Account_Number
      IFSC_Code
      Account_Manager
      Pan_Number
      Email
      Mobile_Number
      Business_Pincode
      Business_Address
      Business_Address_2
      Business_City
      Business_Pan
      Business_State
      GST_Number
      Land_Line
      Aadhar_Number
      Residential_Address
      Residential_Address_2
      Residential_City
      Residential_Pincode
      Residential_State
      Is_Lock
      Is_Mobile_Number_Verified
      Is_Email_Verified
      Is_Bank_Account_Lock
      Is_Verified
      Account_Type
      Aadhar_Card
      Pan_Card
      Proprietor_Photo
      GST_Certificate
      Shop_Act_Licence
      Office_Board_Photo
      MSME_certificate
      Self_Declaration_video
      Other_Doc_1
      Other_Doc_2
      createdAt
      updatedAt
      _id
    }
  }
`;

const AddLedger = ({
  show,
  TypeOfPortal,
  submitType,
  ParentPortalCloseFunction,
  AccountID,
  setShow,
  AddComp = [],
  ReferenceFieldName = [],
  ReferFormKey = "",
}) => {
  console.log(TypeOfPortal, AccountID);
  const { data, refetch } = useQuery(AllData, {
    variables: {
      id: AccountID || "",
    },
  });
  console.log(AddComp, data, "ddddddd");
  const fielddataRedux = useSelector((store) => store.UniqueTableReducer);
  const fielddata = fielddataRedux?.Account_Vouchers?.Selected_Row || fielddataRedux?.Transaction_Checks?.Selected_Row;
  const [selectedRows, setSelectedRows] = useState([]);
  const [deleteVoucher, { loading: deleteLoading }] = useMutation(DELETE_Voucher_MUTATION);
  const rights = useSelector((state) => state.userRightsReducer.userRightsData);
  // console.log(rights["/BankAndCashAccount"], "rightretetertet")
  useEffect(() => {
    if (AccountID) {
      refetch({ id: AccountID || "" });
    }
  }, [AccountID]);

  const [toggle, settoggle] = useState(show ? show : false);
  const [deleteToggle, setDeleteToggle] = useState(show);
  const dispatch = useDispatch();
  console.log(fielddata, "fielddatafielddata");
  useEffect(() => {
    console.log(fielddataRedux?.Account_Vouchers?.Selected_Rows);
    setSelectedRows(
      fielddataRedux?.Account_Vouchers?.Selected_Rows || fielddataRedux?.Transaction_Checks?.Selected_Row
    );
  }, [fielddataRedux]);
  useEffect(() => {
    if (show) {
      settoggle(true);
      setDeleteToggle(true);
      setTimeout(() => {
        settoggle(false);
      }, 3000);
    }
  }, [show]);
  // useEffect(() => {}, [fielddata, toggle, rights, TypeOfPortal]);
  const Closeformfunction = () => {
    ParentPortalCloseFunction(false);
    settoggle(false);
    dispatch({ type: "ClearData", payload: { data: {} } });
    dispatch({ type: "Refetch", payload: true });
  };
  let DeleteVoucher = () => {
    const ArrayOfID = selectedRows.map((obj) => {
      return obj._id;
    });

    deleteVoucher({
      variables: { idsToDelete: ArrayOfID },
    })
      .then((res) => {
        SuccessToast("Voucher Deleted");
        Closeformfunction();
      })
      .catch((err) => {
        ErrorToast(err.message);
      });
  };
  console.log(data?.Account?.Account_Type, "data.Account.Account_Type");
  if (TypeOfPortal === "Delete") {
    return (
      <>
        <Confirm
          toggle={deleteToggle}
          settoggle={setDeleteToggle}
          submit={DeleteVoucher}
          loadingState={deleteLoading ? true : false}
        />
      </>
    );
  }

  console.log(
    data,
    data?.Account,
    data?.Account?.Account_Type === "General Account",
    rights["/GeneralAccount"]?.Is_Edit
  );

  if (TypeOfPortal === "Add") {
    return (
      <AddVoucher
        show={toggle}
        onClose={Closeformfunction}
        ParentPortalCloseFunction={ParentPortalCloseFunction}
        AddComp={AddComp}
        ReferenceFieldName={ReferenceFieldName}
        ReferFormKey={ReferFormKey}
      />
    );
  }
  return (
    <>
      {fielddata &&
      (fielddata.Type === "Journal Voucher" || fielddata.Entry_Type === "Journal Voucher") &&
      rights["/JournalVoucher"]?.Is_Edit ? (
        <AddJournalVoucher
          ParentPortalCloseFunction={ParentPortalCloseFunction}
          show={toggle}
          TypeOfPortal={TypeOfPortal}
          submitType={submitType}
        />
      ) : fielddata &&
        (fielddata.Type === "Bank Payment" || fielddata.Entry_Type === "Bank Payment") &&
        rights["/BankPayment"]?.Is_Edit ? (
        <AddPaymentAccount
          ParentPortalCloseFunction={ParentPortalCloseFunction}
          show={toggle}
          TypeOfPortal={TypeOfPortal}
          submitType={submitType}
        />
      ) : fielddata &&
        (fielddata.Type === "Bank Receipt" || fielddata.Entry_Type === "Bank Receipt") &&
        rights["/BankReceipt"]?.Is_Edit ? (
        <AddBankReceipt
          ParentPortalCloseFunction={ParentPortalCloseFunction}
          show={toggle}
          TypeOfPortal={TypeOfPortal}
          submitType={submitType}
        />
      ) : fielddata &&
        (fielddata.Type === "Cash Payment" || fielddata.Entry_Type === "Cash Payment") &&
        rights["/CashPayment"]?.Is_Edit ? (
        <AddCashPayment
          show={toggle}
          ParentPortalCloseFunction={ParentPortalCloseFunction}
          TypeOfPortal={TypeOfPortal}
          submitType={submitType}
        />
      ) : fielddata &&
        (fielddata.Type === "Cash Receipt" || fielddata.Entry_Type === "Cash Receipt") &&
        rights["/CashReceipt"]?.Is_Edit ? (
        <AddcashReceipt
          show={toggle}
          ParentPortalCloseFunction={ParentPortalCloseFunction}
          TypeOfPortal={TypeOfPortal}
          submitType={submitType}
        />
      ) : fielddata &&
        (fielddata.Type === "Contra Voucher" || fielddata.Entry_Type === "Contra Voucher") &&
        rights["/Contra"]?.Is_Edit ? (
        <AddContra
          show={toggle}
          ParentPortalCloseFunction={ParentPortalCloseFunction}
          TypeOfPortal={TypeOfPortal}
          submitType={submitType}
        />
      ) : fielddata &&
        (fielddata.Type === "Sales Bill" || fielddata.Entry_Type === "Sales Bill") &&
        rights["/SalesBill"]?.Is_Edit ? (
        <AddSalesBill
          show={toggle}
          ParentPortalCloseFunction={ParentPortalCloseFunction}
          TypeOfPortal={TypeOfPortal}
          submitType={submitType}
        />
      ) : fielddata &&
        (fielddata.Type === "Purchase Bill" || fielddata.Entry_Type === "Purchase Bill") &&
        rights["/PurchaseBill"]?.Is_Edit ? (
        <AddPurchaseBill
          show={toggle}
          ParentPortalCloseFunction={ParentPortalCloseFunction}
          TypeOfPortal={TypeOfPortal}
          submitType={submitType}
        />
      ) : fielddata &&
        (fielddata.Type === "Vendor Freight Bill" || fielddata.Entry_Type === "Vendor Freight Bill") &&
        rights["/PurchaseBill"]?.Is_Edit ? (
        <AddVendorFreightBill
          show={toggle}
          ParentPortalCloseFunction={ParentPortalCloseFunction}
          TypeOfPortal={TypeOfPortal}
          submitType={submitType}
        />
      ) : fielddata &&
        (fielddata.Type === "Credit Note" || fielddata.Entry_Type === "Credit Note") &&
        rights["/CreditNote"]?.Is_Edit ? (
        <AddCreditNote
          show={toggle}
          ParentPortalCloseFunction={ParentPortalCloseFunction}
          TypeOfPortal={TypeOfPortal}
          submitType={submitType}
        />
      ) : fielddata &&
        (fielddata.Type === "Debit Note" || fielddata.Entry_Type === "Debit Note") &&
        rights["/DebitNote"]?.Is_Edit ? (
        <AddDebitNOte
          show={toggle}
          ParentPortalCloseFunction={ParentPortalCloseFunction}
          TypeOfPortal={TypeOfPortal}
          submitType={submitType}
        />
      ) : fielddata &&
        (fielddata.Type === "LMS Sales Bill" || fielddata.Entry_Type === "LMS Sales Bill") &&
        rights["/LMSSalesBill"]?.Is_Edit ? (
        <AddLMSSalesBill
          show={toggle}
          ParentPortalCloseFunction={ParentPortalCloseFunction}
          TypeOfPortal={TypeOfPortal}
          submitType={submitType}
        />
      ) : fielddata &&
        (fielddata.Type === "LMS Sales Return" || fielddata.Entry_Type === "LMS Sales Return") &&
        rights["/SalesReturn"]?.Is_Edit ? (
        <AddSalesReturn
          show={toggle}
          ParentPortalCloseFunction={ParentPortalCloseFunction}
          TypeOfPortal={TypeOfPortal}
          submitType={submitType}
        />
      ) : data &&
        data.Account &&
        data.Account.Account_Type === "Vendor Account" &&
        rights["/VendorAccount"]?.Is_Edit ? (
        <AddVendorAccount
          fielddata={data.Account}
          show={show}
          TypeOfPortal={"Edit"}
          // submitType={"Edit"}
          setShow={setShow}
          ParentPortalCloseFunction={ParentPortalCloseFunction}
          ReferenceFieldName={ReferenceFieldName}
          ReferFormKey={ReferFormKey}
        />
      ) : data &&
        data.Account &&
        data.Account.Account_Type === "Customer Account" &&
        rights["/CustomerAccount"]?.Is_Edit ? (
        <AddCustormerAccount
          fielddata={data.Account}
          show={show}
          TypeOfPortal={"Edit"}
          // submitType={"Edit"}
          setShow={setShow}
          ParentPortalCloseFunction={ParentPortalCloseFunction}
          ReferenceFieldName={ReferenceFieldName}
          ReferFormKey={ReferFormKey}
        />
      ) : data &&
        data.Account &&
        data.Account.Account_Type === "Nominal Account" &&
        rights["/NominalAccount"]?.Is_Edit ? (
        <AddNominalAccount
          fielddata={data.Account}
          show={show}
          TypeOfPortal={"Edit"}
          // submitType={"Edit"}
          setShow={setShow}
          ParentPortalCloseFunction={ParentPortalCloseFunction}
          ReferenceFieldName={ReferenceFieldName}
          ReferFormKey={ReferFormKey}
        />
      ) : data && data.Account && data.Account.Account_Type === "Bank And Cash Account" && true ? (
        <AddBankAccount
          fielddata={data.Account}
          show={show}
          TypeOfPortal={"Edit"}
          // submitType={"Edit"}
          setShow={setShow}
          ParentPortalCloseFunction={ParentPortalCloseFunction}
          ReferenceFieldName={ReferenceFieldName}
          ReferFormKey={ReferFormKey}
        />
      ) : data &&
        data.Account &&
        data.Account.Account_Type === "General Account" &&
        rights["/GeneralAccount"]?.Is_Edit ? (
        <AddGeneralAccount
          fielddata={data.Account}
          show={show}
          TypeOfPortal={"Edit"}
          // submitType={"Edit"}
          setShow={setShow}
          ParentPortalCloseFunction={ParentPortalCloseFunction}
          ReferenceFieldName={ReferenceFieldName}
          ReferFormKey={ReferFormKey}
        />
      ) : data && data.Account && data.Account.Account_Type === "App Account" ? (
        <AddCustormerAccount
          fielddata={data.Account}
          show={show}
          TypeOfPortal={"View"}
          submitType={"View"}
          setShow={setShow}
          ParentPortalCloseFunction={ParentPortalCloseFunction}
          ReferenceFieldName={ReferenceFieldName}
          ReferFormKey={ReferFormKey}
        />
      ) : (
        ""
      )}
    </>
  );
};

export default AddLedger;
